// Mock implementation of apollo-angular's gql function
// This allows platform-types to import without the full apollo-angular dependency

export function gql(literals: TemplateStringsArray, ...placeholders: unknown[]): unknown {
    // Simply return the template string as-is
    // This is sufficient for type generation purposes
    let result = "";
    for (let i = 0; i < literals.length; i++) {
        result += literals[i];
        if (i < placeholders.length) {
            result += String(placeholders[i]);
        }
    }
    return result;
}
